import { z } from "zod";
import { fromZodError } from "zod-validation-error";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const readableZodValidationError = (errorMessage: any) => {
  const validationError = fromZodError(errorMessage);

  return validationError;
};

export const customerFirstName = z.object({
  firstName: z
    .string()
    .refine((val) => val.length > 0, {
      message: "Please enter your first name",
    }),
});

export const customerLastName = z.object({
  lastName: z
    .string()
    .refine((val) => val.length > 0, {
      message: "Please enter your last name",
    }),
});

export const customerEmail = z.object({
  email: z
    .string()
    .min(1, { message: "Please enter your email" })
    .email("Enter a valid Email address"),
});
